export default "__VITE_ASSET__Bc4nhqPj__"